export { default } from './OmiseNetbank'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseNetbank/index.js